import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { routes } from '../../../../../constants/routes';
interface FeatureCard {
  icon: string;
  title: string;
  description: string;
}
@Component({
  selector: 'app-about-aikosh',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './about-aikosh.component.html',
  styleUrl: './about-aikosh.component.scss'
})
export class AboutAikoshComponent {
  aikoshAssets = {
    background: 'images/workshop-aikosh.svg',
    ellipse: 'images/ellipse1.svg',
    vectorLeft: 'images/vector.svg',
    vectorRight: 'images/vector-right.svg',
    buildIcon: 'images/build.svg',
    targetIcon: 'images/target.svg',
    explorerIcon: 'images/explorer.svg',
    toolsIcon: 'images/tools.svg'
  };
  constructor(private router: Router) { }

  navigateToHome() {
    this.router.navigate([`/${routes.home}`])
  }

  featureCards: FeatureCard[] = [
    {
      icon: 'images/build.svg',
      title: 'Build projects using real-world data',
      description: 'Develop AI solutions using authentic national datasets and structured workflows.'
    },
    {
      icon: 'images/target.svg',
      title: 'Discover high-quality datasets',
      description: 'Access curated AI-ready datasets across multiple sectors and domains.'
    },
    {
      icon: 'images/explorer.svg',
      title: 'Explore AI use cases',
      description: 'View AI applications developed for real-world challenges across sectors.'
    },
    {
      icon: 'images/tools.svg',
      title: 'Access AI models and tools',
      description: 'Explore pre-built AI models, development tools, and learning resources in one place.'
    }
  ];
}

